import React from "react";

//thumbnails - SP26
import RidwanahBLIMPThumbnail from "../blogposts/SP26/thumbnails/RidwanahBLIMP.webp";
import AmbilaIMUThumbnail from "../blogposts/SP26/thumbnails/AmbilaIMU.webp";

//thumbnails - FA24
import image4 from "../blogposts/FA24/thumbnails/image4.webp";
import tanyaSoftware from "../blogposts/FA24/thumbnails/TanyaSoftware.webp";
import vayunDigitalThumbnail from "../blogposts/FA24/thumbnails/VayunDigital.webp";
import unboxingThumbnail from "../blogposts/FA24/thumbnails/unboxing.webp";
import groundUpThumbnail from "../blogposts/FA24/thumbnails/groundUp.webp";

//thumbnails - SP24
import ASICDesignFlowThumbnail from "../blogposts/SP24/thumbnails/ASICDesignFlow.webp";
import ChipChatterThumbnail from "../blogposts/SP24/thumbnails/ChipChatter.webp";
import chooseFighterThumbnail from "../blogposts/SP24/thumbnails/chooseFighter.webp";
import CMakeThumbnail from "../blogposts/SP24/thumbnails/CMake.webp";
import GDSThumbnail from "../blogposts/SP24/thumbnails/GDS.webp";
import ImgSiliconThumbnail from "../blogposts/SP24/thumbnails/ImgSilicon.webp";
import MagicThumbnail from "../blogposts/SP24/thumbnails/Magic.webp";
import NotEasyThumbnail from "../blogposts/SP24/thumbnails/NotEasy.webp";
import OverCloudThumbnail from "../blogposts/SP24/thumbnails/OverCloud.webp";
import ScrubJayThumbnail from "../blogposts/SP24/thumbnails/ScrubJay.webp";
import TechnicalPMThumbnail from "../blogposts/SP24/thumbnails/TechnicalPM.webp";
import TwoWorldsThumbnail from "../blogposts/SP24/thumbnails/TwoWorlds.webp";
import VerifyBetterFFTThumbnail from "../blogposts/SP24/thumbnails/VerifyBetterFFT.webp";

//thumbnails - FA23
import ABlinkSiliconsPotentialThumbnail from "../blogposts/FA23/thumbnails/ABlinkIntoSiliconsPotential.webp";
import ChippingAwayAtChallengesThumbnail from "../blogposts/FA23/thumbnails/ChippingAwayAtChallenges.webp";
import DesigningAndSynthesizingABetterFFTThumbnail from "../blogposts/FA23/thumbnails/DesigningAndSynthesizingABetterFFT.webp";
import DigitalArtThumbnail from "../blogposts/FA23/thumbnails/DigitalArt.webp";
import ElectronicDesignAutomationThumbnail from "../blogposts/FA23/thumbnails/ElectronicDesignAutomation.webp";
import FromSandToSiliconThumbnail from "../blogposts/FA23/thumbnails/FromSandToSilicon.webp";
import HelloWorldThumbnail from "../blogposts/FA23/thumbnails/HelloWorld.webp";
import IterativeVsUnrolledCalculationsThumbnail from "../blogposts/FA23/thumbnails/IterativeVsUnrolledCalculations.webp";
import MallocFromScratchThumbnail from "../blogposts/FA23/thumbnails/MallocFromScratch.webp";
import PCBDesignThumbnail from "../blogposts/FA23/thumbnails/PCBDesign.webp";
import RepresentingNumbersInHardwareThumbnail from "../blogposts/FA23/thumbnails/RepresentingNumbersInHardware.webp";
import TestAndValOfPCBThumbnails from "../blogposts/FA23/thumbnails/TestAndValOfPCBs.webp";
import TheAnalogSubteamProcessFlowThumbnail from "../blogposts/FA23/thumbnails/TheAnalogSubteamProcessFlow.webp";
import UnravelingBirdSoundsWithSpectrogramsThumbnail from "../blogposts/FA23/thumbnails/UnravelingBirdSoundsWithSpectrograms.webp";

//thumbnails - SP23
import AnalogMultiplexerThumbnail from "../blogposts/SP23/thumbnails/AnalogMultiplexer.webp";
import ConstantGmCurrentReferenceTapeInThumbnail from "../blogposts/SP23/thumbnails/ConstantGmCurrentReferenceTapeIn.webp";
import CrashDetectorsCalculatorsThumbnail from "../blogposts/SP23/thumbnails/CrashDetectorsCalculators.webp";
import DeserializerAndTapeOutUpdateThumbnail from "../blogposts/SP23/thumbnails/DeserializerAndTapeOutUpdate.webp";
import ISPIThumbnail from "../blogposts/SP23/thumbnails/ISPI.webp";
import MagicVLSIvsCadenceVirtuosoThumbnail from "../blogposts/SP23/thumbnails/MagicVLSIvsCadenceVirtuoso.webp";
import ProgressReportThumbnail from "../blogposts/SP23/thumbnails/ProgressReport.webp";
import ProgressReport4_23_23Thumbnail from "../blogposts/SP23/thumbnails/ProgressReport4_23_23.webp";
import ProgressReportMarch2023Thumbnail from "../blogposts/SP23/thumbnails/ProgressReportMarch2023.webp";
import SiliconForScrubJaysThumbnail from "../blogposts/SP23/thumbnails/SiliconForScrubJays.webp";
import SoftwareAndRelativePositionEstimatorThumbnail from "../blogposts/SP23/thumbnails/SoftwareAndRelativePositionEstimator.webp";
import SPIMinionAdapterPythonToolsThumbnail from "../blogposts/SP23/thumbnails/SPIMinion-Adapter-PythonTools.webp";
import SystemArchitectureBlogPostThumbnail from "../blogposts/SP23/thumbnails/SystemArchitectureBlogPost.webp";
import SystemArchitectureProgressReportThumbnail from "../blogposts/SP23/thumbnails/SystemArchitectureProgressReport.webp";
import TheProcessOfAcquiringSponsorsThumbnail from "../blogposts/SP23/thumbnails/TheProcessOfAcquiringSponsors.webp";
import TwoSidesOfACoinThumbnail from "../blogposts/SP23/thumbnails/TwoSidesOfACoin.webp";

function BlogGallery() {
  return (
    <main id="main">
      <section id="apply" className="breadcrumbs">
        <div className="container">
          <div className="section-title">
            <h1>C2S2 Blog</h1>
          </div>
        </div>
      </section>

      <section
        id="posts"
        className="services section-bg"
        style={{ padding: 0 }}
      >
        <div className="container">
          <div className="section-title">
            <p>Spring 2026</p>
          </div>

          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/RidwanahBLIMP">
                  <img loading="lazy" decoding="async" src={RidwanahBLIMPThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Floating Point Integration in BLIMP</h4>
                      <span>Ridwanah Haque</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/AmbilaIMU">
                  <img loading="lazy" decoding="async" src={AmbilaIMUThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Intelligence on a Chip: IMU Motion Classification</h4>
                      <span>Ambila Sivabalan</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="section-title">
            <p>Fall 2024</p>
          </div>

          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/anikaanalog">
                  <img loading="lazy" decoding="async" src={image4} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>The SAR ADC: Refining Digital Output Bit by Bit</h4>
                      <span>Anika Sukthankar</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/tanyasoftware">
                  <img loading="lazy" decoding="async" src={tanyaSoftware} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Sound classNameification Using an IIR Filter</h4>
                      <span>Tanya Datta</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/VayunDigital">
                  <img loading="lazy" decoding="async"
                    src={vayunDigitalThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Digital Design Subteam Advances </h4>
                      <span>Vayun Tiwari</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/groundUp">
                  <img loading="lazy" decoding="async" src={groundUpThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>
                        Building from the Ground Up: The Platforms Subteam's
                        Evolution{" "}
                      </h4>
                      <span>Adele Thompson</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/unboxing">
                  <img loading="lazy" decoding="async" src={unboxingThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Unboxing C2S2's 2024 Spring Tape Outs! </h4>
                      <span>Jason Wang</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="section-title">
            <p>Spring 2024</p>
          </div>

          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/TechnicalPM">
                  <img loading="lazy" decoding="async"
                    src={TechnicalPMThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Sync & Innovate: Technical PM Applied</h4>
                      <span>Taylor Do and Jason Wang</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/VerifyBetterFFT">
                  <img loading="lazy" decoding="async"
                    src={VerifyBetterFFTThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Synthesizing and Verifying a Better FFT</h4>
                      <span>Edmund Lam and Barry Lyu</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ASICDesignFlow">
                  <img loading="lazy" decoding="async"
                    src={ASICDesignFlowThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>From Idea to Chip: ASIC Design Flow</h4>
                      <span>Kevin Rodriguez and Vicky Le</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ImgSilicon">
                  <img loading="lazy" decoding="async" src={ImgSiliconThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Room at the Bottom: Imaging Silicon</h4>
                      <span>Daniel Kaminski and Caden Xu</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/Magic">
                  <img loading="lazy" decoding="async" src={MagicThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Doing Magic in Magic VLSI </h4>
                      <span>Thomas Figura </span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/CMake">
                  <img loading="lazy" decoding="async" src={CMakeThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>C-Making a Build System</h4>
                      <span>Jack Frank and Aidan McNay</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/OverCloud">
                  <img loading="lazy" decoding="async" src={OverCloudThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>
                        Over-the-Cloud Communication using the Particle Argon
                      </h4>
                      <span>Akshati Vaishnav and Kene Chukwuma-Orakwe</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ChipChatter">
                  <img loading="lazy" decoding="async"
                    src={ChipChatterThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Chip Chatter</h4>
                      <span>Abigail Varghese and Adele Thompson</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ScrubJay">
                  <img loading="lazy" decoding="async" src={ScrubJayThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>How to Know a Scrub Jay is a Scrub Jay</h4>
                      <span>Elias Castro</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/TwoWorlds">
                  <img loading="lazy" decoding="async" src={TwoWorldsThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Bridging Two Worlds: Analog-to-Digital Converters</h4>
                      <span>David Bertuch and Jon Ho</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/GDS">
                  <img loading="lazy" decoding="async" src={GDSThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>GDS Chip Art</h4>
                      <span>Emily Lan and Demetrios Gavalas</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/chooseFighter">
                  <img loading="lazy" decoding="async"
                    src={chooseFighterThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>KiCad vs. Altium: Choosing Your Fighter!</h4>
                      <span>Chimdi Anude and Sherri Qazi</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/NotEasy">
                  <img loading="lazy" decoding="async" src={NotEasyThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Making Chips is NOT Easy</h4>
                      <span>Angela Cui and Tomas Choi</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="section-title">
            <p>Fall 2023</p>
          </div>

          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/PCBDesign">
                  <img loading="lazy" decoding="async" src={PCBDesignThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>PCB Design: "There's Layers To It"</h4>
                      <span>Chimdi Anude and Sherri Qazi</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/DesigningAndSynthesizingABetterFFT">
                  <img loading="lazy" decoding="async"
                    src={DesigningAndSynthesizingABetterFFTThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Designing and Synthesizing a Better FFT</h4>
                      <span>Edmund Lam and Barry Lyu</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/TestAndValOfPCBs">
                  <img loading="lazy" decoding="async"
                    src={TestAndValOfPCBThumbnails}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Testing and Validation of Printed Circuit Boards</h4>
                      <span>Akshati Vaishnav and Kene Chukwuma</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ChippingAwayAtChallenges">
                  <img loading="lazy" decoding="async"
                    src={ChippingAwayAtChallengesThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Chipping Away at Challenges: Drafting a Roadmap</h4>
                      <span>Abigail Varghese and Adele Thompson</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ElectronicDesignAutomation">
                  <img loading="lazy" decoding="async"
                    src={ElectronicDesignAutomationThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>
                        Electronic Design Automation: Creating Computers from
                        Code
                      </h4>
                      <span>Angela Cui and Ethan Gabizon</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/UnravelingBirdSoundsWithSpectrograms">
                  <img loading="lazy" decoding="async"
                    src={UnravelingBirdSoundsWithSpectrogramsThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Unraveling Bird Sounds with Spectrograms</h4>
                      <span>Sana Chawla and Jay Patel</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/IterativeVsUnrolledCalculations">
                  <img loading="lazy" decoding="async"
                    src={IterativeVsUnrolledCalculationsThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Iterative vs. Unrolled Calculations</h4>
                      <span>Steven Sun and Aidan McNay</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/DigitalArt">
                  <img loading="lazy" decoding="async" src={DigitalArtThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Digital Art: Principles Of Digital Circuit Design</h4>
                      <span>Setor Simpri and Ena Jovanovic</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/HelloWorld">
                  <img loading="lazy" decoding="async" src={HelloWorldThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>
                        Hello World! New Updates on Sponsorship Packet and
                        Newsletter
                      </h4>
                      <span>Taylor Do and Jason Wang</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/MallocFromScratch">
                  <img loading="lazy" decoding="async"
                    src={MallocFromScratchThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>
                        Malloc from Scratch: Diving into Memory's Secret Keeper
                      </h4>
                      <span>Akanksha Sarkar</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/FromSandToSilicon">
                  <img loading="lazy" decoding="async"
                    src={FromSandToSiliconThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>From Sand To Silicon: ASICs and FPGAs Explained</h4>
                      <span>Tomas Choi and Johnny Martinez</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ABlinkIntoSiliconsPotential">
                  <img loading="lazy" decoding="async"
                    src={ABlinkSiliconsPotentialThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>A Blink Into Silicon's Potential</h4>
                      <span>Ananya Goenka and Elias Castro</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/RepresentingNumbersInHardware">
                  <img loading="lazy" decoding="async"
                    src={RepresentingNumbersInHardwareThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Representing Numbers In Hardware</h4>
                      <span>Mattie Lee and Vicky Le</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/TheAnalogSubteamProcessFlow">
                  <img loading="lazy" decoding="async"
                    src={TheAnalogSubteamProcessFlowThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>The Analog Subteam Process Flow</h4>
                      <span>Thomas Figura and David Bertuch</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="section-title">
            <p>Spring 2023</p>
          </div>

          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/SystemArchitectureBlogPost">
                  <img loading="lazy" decoding="async"
                    src={SystemArchitectureBlogPostThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>System Architecture Blog Post</h4>
                      <span>Matt Hales and Akshati Vaishnav</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/DeserializerAndTapeOutUpdate">
                  <img loading="lazy" decoding="async"
                    src={DeserializerAndTapeOutUpdateThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Deserializer and Tape-Out Update</h4>
                      <span>Vicky Le</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/TwoSidesOfACoin">
                  <img loading="lazy" decoding="async"
                    src={TwoSidesOfACoinThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>
                        Two Sides Of A Coin: How Modules on a Chip Communicate
                      </h4>
                      <span>Tomas Choi and Kevin Liu</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/MagicVLSIvsCadenceVirtuoso">
                  <img loading="lazy" decoding="async"
                    src={MagicVLSIvsCadenceVirtuosoThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Magic VLSI vs. Cadence Virtuoso</h4>
                      <span>Thomas Figura and Aidan McNay</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ProgressReport4_23_23">
                  <img loading="lazy" decoding="async"
                    src={ProgressReport4_23_23Thumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Progress Report - 4/23/2023</h4>
                      <span>Christopher Schiff and Johnny Martinez</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/SoftwareAndRelativePositionEstimator">
                  <img loading="lazy" decoding="async"
                    src={SoftwareAndRelativePositionEstimatorThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Software and Relative Position Estimator</h4>
                      <span>Akanksha Sarkar and Sana Chawla</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/SPIMinionAdapterPythonTools">
                  <img loading="lazy" decoding="async"
                    src={SPIMinionAdapterPythonToolsThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>SPI Minion, Adapter, & Python Tools</h4>
                      <span>Alga Peng and Xiangyi Zhao</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/SiliconForScrubJays">
                  <img loading="lazy" decoding="async"
                    src={SiliconForScrubJaysThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Silicon For Scrubs Jays</h4>
                      <span>Chidera Wokonko and Abigail Varghese</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/AnalogMultiplexer">
                  <img loading="lazy" decoding="async"
                    src={AnalogMultiplexerThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Analog Multiplexer</h4>
                      <span>Adele Thompson and David Bertuch</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ISPI">
                  <img loading="lazy" decoding="async" src={ISPIThumbnail} className="img-fluid" alt="" />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>I SPI</h4>
                      <span>Austin Brown and Mika Finkman</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/CrashDetectorsAndCalculators">
                  <img loading="lazy" decoding="async"
                    src={CrashDetectorsCalculatorsThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Crash Detectors & Calculators</h4>
                      <span>Ananya Goenka and Michael Wei</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/SystemArchitectureProgressReport">
                  <img loading="lazy" decoding="async"
                    src={SystemArchitectureProgressReportThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>System Architecture Progress Report</h4>
                      <span>Chimdi Anude and Kene Chukwuma-Orakwe</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ProgressReportMarch2023">
                  <img loading="lazy" decoding="async"
                    src={ProgressReportMarch2023Thumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Progress Report - March 2023</h4>
                      <span>Dylan Tom and Edmund Lam</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/TheProcessOfAcquiringSponsors">
                  <img loading="lazy" decoding="async"
                    src={TheProcessOfAcquiringSponsorsThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>The Process of Acquiring Sponsors</h4>
                      <span>Jasmine Samadi and Jay Patel</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ProgressReport">
                  <img loading="lazy" decoding="async"
                    src={ProgressReportThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>Progress Report</h4>
                      <span>Will Salcedo and Steven Sun</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 d-block align-items-center"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="post">
                <a href="/blog/ConstantGmCurrentReferenceTapeIn">
                  <img loading="lazy" decoding="async"
                    src={ConstantGmCurrentReferenceTapeInThumbnail}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="post-info">
                    <div className="post-info-content">
                      <h4>
                        Constant-g<sub>m</sub> Current Reference Tape-In
                      </h4>
                      <span>Jon Ho and Emmi Wyttenbach</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default BlogGallery;
